module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("84olK"))).then(() => module.bundle.root('dJXJK'));